import { render, staticRenderFns } from "./ProjectStagesList.vue?vue&type=template&id=a972d8ca&scoped=true&"
import script from "./ProjectStagesList.vue?vue&type=script&lang=js&"
export * from "./ProjectStagesList.vue?vue&type=script&lang=js&"
import style0 from "./ProjectStagesList.vue?vue&type=style&index=0&id=a972d8ca&lang=scss&scoped=true&"
import style1 from "./ProjectStagesList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a972d8ca",
  null
  
)

export default component.exports